import { FormLabel, Grid } from "@material-ui/core";

import { RadioQuestion } from "./RadioQuestion";
import { Paper } from "@material-ui/core";
import { useEffect, useState } from "react";
import { LazyLoading } from "@/components/loaders/Loader/LazyLoading";
import type { FormInstanceRowExtended } from "../models/FormInstanceRowExtended";
import type { GroupedSection } from "../models/GroupedSection";
import type { GroupedQuestion } from "../models/GroupedQuestion";

type Props = {
	formInstanceSections?: (GroupedSection | FormInstanceRowExtended[])[] | null;
	formInstanceQuestions?: (GroupedQuestion | FormInstanceRowExtended[])[];
	layoutCode?: string;
};

export const Questions = ({
	formInstanceSections,
	formInstanceQuestions,
	layoutCode,
}: Props) => {
	const [mounted, setMounted] = useState(false);
	useEffect(() => {
		setMounted(true);
	}, []);

	if (formInstanceSections?.length === 0 || !mounted)
		return (
			<>
				<div style={{ display: "flex", justifyContent: "center" }}>
					<LazyLoading />
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						fontSize: "20px",
					}}
				>
					Loading...
				</div>
			</>
		);

	return (
		<>
			{layoutCode === "D" &&
				formInstanceSections &&
				formInstanceSections.map(
					(
						section: GroupedSection | FormInstanceRowExtended[],
						sectionIndex: number,
					) => {
						const sectionData = (section as GroupedSection).rows || section;
						const firstRow = Array.isArray(sectionData)
							? (sectionData[0] as FormInstanceRowExtended)
							: (sectionData as FormInstanceRowExtended);

						const sectionQuestions =
							formInstanceQuestions?.filter(
								(q: GroupedQuestion | FormInstanceRowExtended[]) => {
									const questionData = (q as GroupedQuestion).rows || q;
									const firstQuestionRow = Array.isArray(questionData)
										? (questionData[0] as FormInstanceRowExtended)
										: (questionData as FormInstanceRowExtended);
									return firstQuestionRow.SectionId === firstRow.SectionId;
								},
							) || [];

						const firstColumn = sectionQuestions.slice(
							0,
							Math.ceil(sectionQuestions.length / 2),
						);
						const secondColumn = sectionQuestions.slice(
							Math.ceil(sectionQuestions.length / 2),
						);

						return (
							<div key={`${firstRow.SectionName}-${firstRow.SectionId}`}>
								<Paper
									elevation={1}
									style={{
										width: "100%",
										padding: "10px 0px 10px 10px",
										borderRadius: "0.1rem",
										borderBottom: "unset",
										backgroundColor: firstRow.BackgroundColor,
									}}
								>
									<FormLabel
										id="demo-row-radio-buttons-group-label"
										className="Mui-focused"
										style={{
											display: "flex",
											justifyContent: "center",
											fontSize: "16px",
											textTransform: "uppercase",
										}}
									>
										{firstRow.SectionName}
									</FormLabel>
									<FormLabel
										id="demo-row-radio-buttons-group-label"
										className="Mui-focused"
										style={{
											display: "flex",
											justifyContent: "center",
											fontSize: "14px",
											textTransform: "uppercase",
											color: "#505050",
										}}
									>
										{firstRow.SubTitle}
									</FormLabel>

									<Grid container spacing={5} style={{ padding: "10px" }}>
										<Grid item md={6} xs={6}>
											{firstColumn.map(
												(
													question: GroupedQuestion | FormInstanceRowExtended[],
												) => {
													const questionData =
														(question as GroupedQuestion).rows || question;
													const firstQuestionRow = Array.isArray(questionData)
														? (questionData[0] as FormInstanceRowExtended)
														: (questionData as FormInstanceRowExtended);
													if (firstQuestionRow.QuestionTypeCode === "R") {
														return (
															<RadioQuestion
																key={firstQuestionRow.QuestionId}
																question={[
																	String(
																		(question as GroupedQuestion).questionId ||
																			firstQuestionRow.QuestionId,
																	),
																	questionData as FormInstanceRowExtended[],
																]}
															/>
														);
													}
													return null;
												},
											)}
										</Grid>
										<Grid item md={6} xs={6}>
											{secondColumn.map(
												(
													question: GroupedQuestion | FormInstanceRowExtended[],
												) => {
													const questionData =
														(question as GroupedQuestion).rows || question;
													const firstQuestionRow = Array.isArray(questionData)
														? (questionData[0] as FormInstanceRowExtended)
														: (questionData as FormInstanceRowExtended);
													if (firstQuestionRow.QuestionTypeCode === "R") {
														return (
															<RadioQuestion
																key={firstQuestionRow.QuestionId}
																question={[
																	String(
																		(question as GroupedQuestion).questionId ||
																			firstQuestionRow.QuestionId,
																	),
																	questionData as FormInstanceRowExtended[],
																]}
															/>
														);
													}
													return null;
												},
											)}
										</Grid>
									</Grid>
								</Paper>
								{sectionIndex < formInstanceSections.length - 1 && <hr />}
							</div>
						);
					},
				)}

			{layoutCode === "T" && (
				<Grid container spacing={1}>
					{/* First Column */}
					<Grid item lg={4} md={6} xs={12}>
						{formInstanceSections &&
							formInstanceSections
								.filter(
									(section: GroupedSection | FormInstanceRowExtended[]) => {
										const sectionData =
											(section as GroupedSection).rows || section;
										const firstRow = Array.isArray(sectionData)
											? sectionData[0]
											: sectionData;
										return firstRow.LayoutParameters === "Column=1";
									},
								)
								.map((section: GroupedSection | FormInstanceRowExtended[]) => {
									const sectionData =
										(section as GroupedSection).rows || section;
									const firstRow = Array.isArray(sectionData)
										? sectionData[0]
										: sectionData;

									return (
										<Paper
											key={`${firstRow.SectionName}-${firstRow.SectionId}`}
											elevation={1}
											style={{
												width: "100%",
												padding: "10px 0px 10px 10px",
												marginBottom: "10px",
												borderRadius: "0.1rem",
												backgroundColor: firstRow.BackgroundColor,
											}}
										>
											<div>
												<FormLabel
													id="demo-row-radio-buttons-group-label"
													className="Mui-focused"
													style={{
														display: "flex",
														justifyContent: "center",
														fontSize: "16px",
														textTransform: "uppercase",
														paddingBottom: "-10px",
													}}
												>
													{firstRow.SectionName}
												</FormLabel>
												<FormLabel
													id="demo-row-radio-buttons-group-label"
													className="Mui-focused"
													style={{
														display: "flex",
														justifyContent: "center",
														fontSize: "14px",
														textTransform: "uppercase",
														color: "#505050",
													}}
												>
													{firstRow.SubTitle}
												</FormLabel>
												{formInstanceQuestions &&
													formInstanceQuestions
														.filter(
															(
																q: GroupedQuestion | FormInstanceRowExtended[],
															) => {
																const questionData =
																	(q as GroupedQuestion).rows || q;
																const firstQuestionRow = Array.isArray(
																	questionData as FormInstanceRowExtended[],
																)
																	? (
																			questionData as FormInstanceRowExtended[]
																		)[0]
																	: (questionData as unknown as FormInstanceRowExtended);
																return (
																	firstQuestionRow.SectionId ===
																	firstRow.SectionId
																);
															},
														)
														.map(
															(
																question:
																	| GroupedQuestion
																	| FormInstanceRowExtended[],
															) => {
																const questionData =
																	(question as GroupedQuestion).rows ||
																	question;
																const firstQuestionRow = Array.isArray(
																	questionData as FormInstanceRowExtended[],
																)
																	? (
																			questionData as FormInstanceRowExtended[]
																		)[0]
																	: (questionData as unknown as FormInstanceRowExtended);
																if (firstQuestionRow.QuestionTypeCode === "R") {
																	return (
																		<RadioQuestion
																			key={firstQuestionRow.QuestionId}
																			question={[
																				String(
																					(question as GroupedQuestion)
																						.questionId ||
																						firstQuestionRow.QuestionId,
																				),
																				questionData as FormInstanceRowExtended[],
																			]}
																		/>
																	);
																}
																return null;
															},
														)}
											</div>
										</Paper>
									);
								})}
					</Grid>

					{/* Second Column */}
					<Grid item lg={4} md={6} xs={12}>
						{formInstanceSections &&
							formInstanceSections
								.filter(
									(section: GroupedSection | FormInstanceRowExtended[]) => {
										const sectionData =
											(section as GroupedSection).rows || section;
										const firstRow = Array.isArray(sectionData)
											? sectionData[0]
											: sectionData;
										return firstRow.LayoutParameters === "Column=2";
									},
								)
								.map((section: GroupedSection | FormInstanceRowExtended[]) => {
									const sectionData =
										(section as GroupedSection).rows || section;
									const firstRow = Array.isArray(sectionData)
										? sectionData[0]
										: sectionData;

									return (
										<Paper
											key={`${firstRow.SectionName}-${firstRow.SectionId}`}
											elevation={1}
											style={{
												width: "100%",
												padding: "10px 0px 10px 10px",
												marginBottom: "10px",
												borderRadius: "0.1rem",
												backgroundColor: firstRow.BackgroundColor,
											}}
										>
											<div>
												<FormLabel
													id="demo-row-radio-buttons-group-label"
													className="Mui-focused"
													style={{
														display: "flex",
														justifyContent: "center",
														fontSize: "16px",
														textTransform: "uppercase",
														paddingBottom: "-10px",
													}}
												>
													{firstRow.SectionName}
												</FormLabel>
												<FormLabel
													id="demo-row-radio-buttons-group-label"
													className="Mui-focused"
													style={{
														display: "flex",
														justifyContent: "center",
														fontSize: "14px",
														textTransform: "uppercase",
														color: "#505050",
													}}
												>
													{firstRow.SubTitle}
												</FormLabel>

												{formInstanceQuestions &&
													formInstanceQuestions
														.filter(
															(
																q: GroupedQuestion | FormInstanceRowExtended[],
															) => {
																const questionData =
																	(q as GroupedQuestion).rows || q;
																const firstQuestionRow = Array.isArray(
																	questionData as FormInstanceRowExtended[],
																)
																	? (
																			questionData as FormInstanceRowExtended[]
																		)[0]
																	: (questionData as unknown as FormInstanceRowExtended);
																return (
																	firstQuestionRow.SectionId ===
																	firstRow.SectionId
																);
															},
														)
														.map(
															(
																question:
																	| GroupedQuestion
																	| FormInstanceRowExtended[],
															) => {
																const questionData =
																	(question as GroupedQuestion).rows ||
																	question;
																const firstQuestionRow = Array.isArray(
																	questionData as FormInstanceRowExtended[],
																)
																	? (
																			questionData as FormInstanceRowExtended[]
																		)[0]
																	: (questionData as unknown as FormInstanceRowExtended);
																if (firstQuestionRow.QuestionTypeCode === "R") {
																	return (
																		<RadioQuestion
																			key={firstQuestionRow.QuestionId}
																			question={[
																				String(
																					(question as GroupedQuestion)
																						.questionId ||
																						firstQuestionRow.QuestionId,
																				),
																				questionData as FormInstanceRowExtended[],
																			]}
																		/>
																	);
																}
																return null;
															},
														)}
											</div>
										</Paper>
									);
								})}
					</Grid>

					{/* Third Column */}
					<Grid item lg={4} md={6} xs={12}>
						{formInstanceSections &&
							formInstanceSections
								.filter(
									(section: GroupedSection | FormInstanceRowExtended[]) => {
										const sectionData =
											(section as GroupedSection).rows || section;
										const firstRow = Array.isArray(sectionData)
											? sectionData[0]
											: sectionData;
										return firstRow.LayoutParameters === "Column=3";
									},
								)
								.map((section: GroupedSection | FormInstanceRowExtended[]) => {
									const sectionData =
										(section as GroupedSection).rows || section;
									const firstRow = Array.isArray(sectionData)
										? sectionData[0]
										: sectionData;

									return (
										<Paper
											key={`${firstRow.SectionName}-${firstRow.SectionId}`}
											elevation={1}
											style={{
												width: "100%",
												padding: "10px 0px 10px 10px",
												marginBottom: "10px",
												borderRadius: "0.1rem",
												backgroundColor: firstRow.BackgroundColor,
											}}
										>
											<div>
												<FormLabel
													id="demo-row-radio-buttons-group-label"
													className="Mui-focused"
													style={{
														display: "flex",
														justifyContent: "center",
														fontSize: "16px",
														textTransform: "uppercase",
														paddingBottom: "-10px",
													}}
												>
													{firstRow.SectionName}
												</FormLabel>
												<FormLabel
													id="demo-row-radio-buttons-group-label"
													className="Mui-focused"
													style={{
														display: "flex",
														justifyContent: "center",
														fontSize: "14px",
														textTransform: "uppercase",
														color: "#505050",
													}}
												>
													{firstRow.SubTitle}
												</FormLabel>

												{formInstanceQuestions &&
													formInstanceQuestions
														.filter(
															(
																q: GroupedQuestion | FormInstanceRowExtended[],
															) => {
																const questionData =
																	(q as GroupedQuestion).rows || q;
																const firstQuestionRow = Array.isArray(
																	questionData as FormInstanceRowExtended[],
																)
																	? (
																			questionData as FormInstanceRowExtended[]
																		)[0]
																	: (questionData as unknown as FormInstanceRowExtended);
																return (
																	firstQuestionRow.SectionId ===
																	firstRow.SectionId
																);
															},
														)
														.map(
															(
																question:
																	| GroupedQuestion
																	| FormInstanceRowExtended[],
															) => {
																const questionData =
																	(question as GroupedQuestion).rows ||
																	question;
																const firstQuestionRow = Array.isArray(
																	questionData as FormInstanceRowExtended[],
																)
																	? (
																			questionData as FormInstanceRowExtended[]
																		)[0]
																	: (questionData as unknown as FormInstanceRowExtended);
																if (firstQuestionRow.QuestionTypeCode === "R") {
																	return (
																		<RadioQuestion
																			key={firstQuestionRow.QuestionId}
																			question={[
																				String(
																					(question as GroupedQuestion)
																						.questionId ||
																						firstQuestionRow.QuestionId,
																				),
																				questionData as FormInstanceRowExtended[],
																			]}
																		/>
																	);
																}
																return null;
															},
														)}
											</div>
										</Paper>
									);
								})}
					</Grid>
				</Grid>
			)}
		</>
	);
};
